import React, { useEffect } from "react";

const LiveHistory = ({ title, data }) => {

  useEffect(() => {
    console.log("data", title, data)
  }, [data])
 
  return (
    <div className="my-3 flex items-center justify-center">
      <div className="bg-gray-800 p-2 p-sm-3 p-md-3 p-lg-3 w-full rounded-lg shadow-lg  ">
        <div className="w-full justify-content-between d-flex">
          <p className="text-sm text-white font-semibold mb-3">
            Live {title}
          </p>
        </div>

        <div>
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg  live-data">
            <table className="w-full text-sm text-left rtl:text-right text-white ">
              <thead className="text-xs text-white uppercase bg-gray-700 ">
                <tr>
                  <th scope="col" className="px-2 py-1">
                    player
                  </th>

                  <th scope="col" className="px-2 py-1">
                    {title}
                  </th>
                  <th scope="col" className="px-2 py-1">
                    Profit
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {data?.map((d, index) => (
                  <tr
                    key={index}
                    className="odd:bg-gray-800  even:bg-gray-800  border-b"
                  >
                    <th
                      scope="row"
                      className="px-3 py-2 font-medium text-white whitespace-nowrap "
                    >
                      {d?.username || d?.user?.username} 
                    </th>

                    <td className={d.isWin ? "f-green" : "text-white" + "px-3 py-2"}>
                      {title == 'Bets' ? d.betAmount?.toFixed(2) : d.cashedOut?.toFixed(2)+'X'}
                      </td>
                    <td className={d.isWin ? "f-green" : "text-white" + "px-3 py-2"}>{d.winAmount?.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveHistory;
